module.exports = __webpack_public_path__ + "static/media/Breloom_gaussian2.d3abe038.png";